import { ref } from "vue"

/**
 * Represents the different application modes.
 */
export enum ApplicationMode {
	OC = 'oc',
	LZ = 'lz',
	PAYMENT = 'payment'
}

/**
 * Composable function to determine the current application mode based on the hostname.
 *
 * @returns {Object} An object containing the current application mode.
 */
export const useApplication = () => {
	const mode = ref<ApplicationMode>(ApplicationMode.LZ); // Default to LZ

	const hostname = window.location.hostname;

	switch (hostname) {
		case import.meta.env.VITE_APP_OC_HOSTNAME:
			mode.value = ApplicationMode.OC;
			break;
		case import.meta.env.VITE_APP_PAYMENT_HOSTNAME:
			mode.value = ApplicationMode.PAYMENT;
			break;
		case import.meta.env.VITE_APP_LZ_HOSTNAME:
			mode.value = ApplicationMode.LZ;
			break;
		default:
			mode.value = import.meta.env.VITE_APP_DEFAULT_MODE as ApplicationMode || ApplicationMode.LZ;
	}

	if (import.meta.env.VITE_APP_OVERRIDE_MODE) {
		mode.value = import.meta.env.VITE_APP_OVERRIDE_MODE as ApplicationMode;
	}

	return {
		mode
	};
}
